export const isAviosAuthEnabled = (type: string): boolean =>
  process.env.NEXT_PUBLIC_AVIOS_CENTRAL_AUTH?.trim().toLowerCase() === 'true' &&
  process.env.NEXT_PUBLIC_PLATFORM_TYPE !== 'whitelabel' &&
  type === 'avios'
